module.exports = __webpack_public_path__ + "img/Productivity.a910b803.png";